<!-- Bootstrap Modal -->
<div #withdrawModal class="modal fade" id="withdrawModal" tabindex="-1" role="dialog" aria-labelledby="withdrawModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="withdrawModalLabel">{{ 'Withdraw Balance' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onCancel()" [disabled]="submitting">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{{ 'Current Balance' | translate }}: {{ maxAmount | number:'1.2-2' }}</p>
        <div class="form-group">
          <label for="withdrawAmount">{{ 'Withdrawal Amount' | translate }}</label>
          <input
            type="number"
            class="form-control"
            id="withdrawAmount"
            [(ngModel)]="withdrawAmount"
            [max]="maxAmount"
            [min]="0"
            [disabled]="submitting">
          <small class="text-danger" *ngIf="errorMessage">{{ errorMessage }}</small>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="onCancel()" [disabled]="submitting">{{ 'Cancel' | translate }}</button>
        <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="submitting">
          <span *ngIf="submitting" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
          {{ 'Submit' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
